import { render, staticRenderFns } from "./DisponibilitatTecnica.vue?vue&type=template&id=7fe147e8&"
import script from "./DisponibilitatTecnica.vue?vue&type=script&lang=js&"
export * from "./DisponibilitatTecnica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports